export { default } from './CGMIndicator';
